import React, { Component } from "react";

class ModalContent extends Component {
  render() {
    return (
      <div
        className={`modal-content ${
          this.props.className ? this.props.className : ""
        }`}
      >
        {this.props.children}
      </div>
    );
  }
}

export default ModalContent;
